import React, { memo } from "react";
import "../dateFrameInput/DateFrameInput.css";
import ProfileEditDate from "../../../profileEditDate/ProfileEditDate";

const TimeFrameInput = ({ label, values, setValues, error }) => {
  return (
    <div className="timeframe-bg">
      <label>{label}</label>
      <div className="timeframe-input-bg">
        <div style={{ position: "relative", flex: 1 }}>
          <ProfileEditDate
            placeholder="DD-MM-YYY"
            widthCon={"100%"}
            type="time"
            step="3600"
            value={values.time_from}
            customStyles={{
              label: {
                color: "#245293",
                fontWeight: 600,
              },
              input: {
                borderRadius: "0px",
                border: `1px solid ${error?.time_from ? "red" : "#000"}`,
              },
              bg: {
                flex: "1",
              },
            }}
            onChange={(e) => {
              let [hour] = e.target.value.split(":").map(Number);
              if (hour < 10) {
                setValues((prev) => ({
                  ...prev,
                  time_from: `0${hour}:00`,
                }));
              } else {
                setValues((prev) => ({
                  ...prev,
                  time_from: `${hour}:00`,
                }));
              }
            }}
            // step="1"
          />
          {error?.time_from && (
            <span
              style={{
                fontSize: "12px",
                color: "red",
                position: "absolute",
                top: -8,
                right: 0,
              }}
            >
              {error?.time_from}
            </span>
          )}
        </div>

        <div>to</div>

        <div style={{ position: "relative", flex: 1 }}>
          <ProfileEditDate
            placeholder="DD-MM-YYY"
            widthCon={"100%"}
            type="time"
            step="3600"
            value={values.time_to}
            customStyles={{
              label: {
                color: "#245293",
                fontWeight: 600,
              },
              input: {
                borderRadius: "0px",
                border: `1px solid ${error?.time_to ? "red" : "#000"}`,
              },
              bg: {
                flex: "1",
              },
            }}
            onChange={(e) => {
              let [hour] = e.target.value.split(":").map(Number);
              if (hour < 10) {
                setValues((prev) => ({
                  ...prev,
                  time_to: `0${hour}:00`,
                }));
              } else {
                setValues((prev) => ({
                  ...prev,
                  time_to: `${hour}:00`,
                }));
              }
            }}
          />
          {error?.time_to && (
            <span
              style={{
                fontSize: "12px",
                color: "red",
                position: "absolute",
                top: -8,
                right: 0,
              }}
            >
              {error?.time_to}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(TimeFrameInput);
